
<template>
  <div>
      <md-card>
          <md-card-header>
            <div class="md-title"></div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-20">
                    <md-datepicker v-model="params.start_date">
                          <label>Inicio</label>
                      </md-datepicker>
                  </div>
                   <div class="md-layout-item md-size-20">
                    <md-datepicker v-model="params.end_date">
                          <label>Fim</label>
                      </md-datepicker>
                  </div> 
                  <div class="md-layout-item md-size-30">
                    <md-autocomplete v-model="params.customer.name" :md-options="customers" @md-changed="changeCustomer" @md-selected="slectedCustomer">
                        <label>Cliente</label>

                        <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.name }}</template>
                      </md-autocomplete>
                  </div>
                   <div class="md-layout-item md-size-30">
                     <md-button class="md-raised" @click="clearSearch">Limpar</md-button>
                     <md-button class="md-raised md-primary" @click="search">Buscar</md-button>
                   </div>
                  
            </div>              
              </md-card-content>
        </md-card>  
        <br>    
  </div>
</template>

<script>

import search from '../../search';
 
export default {
  data(){
    return {
        customers: [],
        params:{
           customer:{},
        },        
    }
  },  
  mixins:[search],
  mounted(){
      this.$material.locale.dateFormat = "dd/MM/yyyy";
  },
  methods:{     
    search(){
  
      if(this.params.customer != undefined){
        this.params.id_customer = this.params.customer.id
      }
      this.$emit("search",this.params)
    },  
     
  }
};
</script>
